import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

import { AppRetailerBlock } from '@components';

/**
 * The rows of the table. On the site axis they get the logo and the flag every other analyzer
 * puts on a web; on the provider axis the brand name travels alone — a brand has no market and
 * no domain of its own.
 */
export default function axisColumn(isSiteAxis) {
	return {
		name: 'name',
		setBodyRowProps: () => ({ sx: { p: 0, backgroundColor: 'primary.main' } }),
		setBodyCellProps: () => ({
			sx: {
				verticalAlign: 'top',
				p: 1,
				pl: 2,
				backgroundColor: 'primary.main',
				border: 0,
				userSelect: 'none',
				cursor: 'default',
				position: 'sticky',
				top: 0,
				left: 0,
				zIndex: '150 !important',
			},
		}),
		render: (name, row) => <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1, minHeight: 40 }}>
			{isSiteAxis
				// the block writes its own Typography, so the contrast of the header column is
				// set on the wrapper and inherited
				? <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, color: 'secondary.contrastText' }}>
					<AppRetailerBlock retailer={name} icon={row?.nameIcon} country={row?.nameMarket} />
				</Box>
				: <Typography
					sx={{ textAlign: 'left', color: 'secondary.contrastText' }}
					variant="subtitle1"
					fontWeight={600}
				>
					{name}
				</Typography>}
			{/* the row every other fee is measured against, same "you" tag the other analyzers use */}
			{row?.isMainRow && <Chip label="you" size="small" color="primary" sx={{ height: 18, fontSize: '0.65rem' }} />}
		</Box>
	};
}
